import { Component, createRef } from 'react';
import {
  DataGrid,
  Column,
  Editing,
  Selection,
  SearchPanel,
  ColumnChooser,
  Grouping,
  GroupPanel,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Search,
} from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import { ContextMenu as DxContextMenu } from "devextreme-react/context-menu";
import ContextMenu from "devextreme/ui/context_menu";
import { Template } from 'devextreme-react/core/template';
import { Popup } from 'devextreme-react/popup';
import { EditSchoolPopup } from '../schools/edit-school-popup';
import { EditCommitteeForm } from './edit-committee-form';
import { AddMemberPopup } from './add-member-popup';
import { CurrentSwitch } from '~/components/current-switch/current-switch';
import {calcGridHeight} from '~/helpers/ui';
import {
  CreateAuthorizedStore,
  CreateAuthorizedDataSource,
  getSchoolById,
  getAuthorizationTokenAsync,
} from '~/helpers/data';
import { appConst } from '~/app-const';
import './committees.scss';

const URL = `${window.env.apiEndpoint}/api/v1/CommitteeMemberships`;
const standardRowRenderingMode = { scrolling: { mode: "virtual", rowRenderingMode: "standard" } };
const dataSource = CreateAuthorizedStore(
  {
    loadUrl: `${URL}/GetCommittees`,
    insertUrl: `${URL}/Post`,
    updateUrl: `${URL}/Put`,
    deleteUrl: `${URL}/DeleteCommittee`,
  },
  null, 'Id',
);

const schoolYearsDataSource = CreateAuthorizedStore(
  {
    loadUrl: `${URL}/SchoolYearsLookup`,
  },
  null, 'Value',
);

const committeeGroupsData = CreateAuthorizedDataSource(
  {
    loadUrl: `${window.env.apiEndpoint}/api/v1/CommitteeGroups/CommitteeGroupsLookup`,
  },
  null, 'Value',
  null, 'Header',
);

export class Committees extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEditForm: false,
      addNewMode: false,
      editFormHeight: 0,
      rowData: {},
      title: '',
      membersLookupData: {},
      showAddMemberPopup: false,
    };

    this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
    this.toolbarItemRender = this.toolbarItemRender.bind(this);
    this.windowResized = this.windowResized.bind(this);
    this.editIconClick = this.editIconClick.bind(this);
    this.hideEditPopup = this.hideEditPopup.bind(this);
    this.committeeGroupsData = committeeGroupsData;
    this.refreshGrid = this.refreshGrid.bind(this);
    this.changeEditFormTitle = this.changeEditFormTitle.bind(this);
    this.setMemberAutoCompleteSearchProperties = this.setMemberAutoCompleteSearchProperties.bind(this);
    this.hideAddMemberPopup = this.hideAddMemberPopup.bind(this);
    this.showHideSchoolEditForm = this.showHideSchoolEditForm.bind(this);
    this.fetchEmails = this.fetchEmails.bind(this);
    this.getContextMenu = this.getContextMenu.bind(this);
    this.editCommitteeFormRef = createRef();
    this.CommitteesGridRef = createRef();
  }

  toolbarItemRender() {
    return (
      <CurrentSwitch grid={this.CommitteesGridRef} />
    );
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift(
      {
        template: 'switchCurrent',
        location: 'left',
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          onClick: this.addIconClick.bind(this),
        },
      },
    );
  }

  componentDidMount() {
    window.addEventListener('resize', this.windowResized);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResized);
  }

  windowResized() {
    this.CommitteesGridRef.current.instance().option('height', calcGridHeight('CommitteesGrid'));
  }

  editIconClick(rowData) {
    schoolYearsDataSource.load().done((data) => {
      this.setState({
        showEditForm: true,
        committeeId: rowData.Id,
        addNewMode: false,
        schoolYearsData: data,
        rowData: { ...rowData },
        editFormTitle: rowData.Description,
      });
    });
  }

  addIconClick() {
    schoolYearsDataSource.load().done((data) => {
      this.setState({
        showEditForm: true,
        addNewMode: true,
        schoolYearsData: data,
        committeeId: 0,
        editFormTitle: '(New Committee)',
        rowData: { Current: true },
      });
    });
  }

  hideEditPopup() {
    this.setState({
      rowData: {},
      showEditForm: false,
    });
  }

  refreshGrid() {
    this.CommitteesGridRef.current.instance().refresh();
  }

  changeEditFormTitle(committeeName) {
    this.setState(
      { editFormTitle: committeeName },
    );
  }

  // this function is used to set the state from he child component EditCommitteeForm
  setMemberAutoCompleteSearchProperties(data, showAddMemberPopup,
    selectedCommitteeId, selectedSchoolYearId, membersGridRef,
    selectedStartDate, selectedEndDate) {
    this.setState({
      membersLookupData: data,
      showAddMemberPopup,
      selectedCommitteeId,
      selectedSchoolYearId,
      membersGridRef,
      selectedStartDate,
      selectedEndDate,
    });
  }

  hideAddMemberPopup() {
    this.setState({ showAddMemberPopup: false });
  }

  showHideSchoolEditForm(value, schoolId) {
    if (value) {
      getSchoolById(schoolId).then(
        (result) => {
          this.setState({
            schoolRowData: { ...result },
            showEditSchoolForm: true,
          });
        },
      );
    } else {
      this.setState({
        showEditSchoolForm: false,
      });
    }
  }

  renderEditSchoolPopup(isEditFormShown) {
    if (isEditFormShown) {
      const { schoolRowData } = this.state;
      return (
        <EditSchoolPopup
          rowData={schoolRowData}
          title={schoolRowData.Name}
          showHideSchoolEditForm={this.showHideSchoolEditForm}
          refreshMembersGrid={() => this.editCommitteeFormRef.current.refreshMembersGrid()}
          addNewMode={false}
          showEditForm={isEditFormShown}
        />
      );
    }
  }

  getContextMenu() {
    const el = document.getElementById("contextMenu");
    const menu = ContextMenu.getInstance(el);

    return menu;
  }

  async fetchEmails(emailType) {

    const token = await getAuthorizationTokenAsync();
    const menu = this.getContextMenu();
    const params = {
      committeeId: menu.option('committeeId'),
      emailType: emailType,
    };

  
    const response = await fetch(`${URL}/GetEmails?${new URLSearchParams(params)}`, {
      method: "Get",
      headers: new Headers({
        'Authorization': `Bearer ${token.accessToken}`,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${await response.text()}`);
    }

    const data = await response.json();
    return data;
  }

  render() {
    const {
      showEditForm, committeeId, schoolYearsData,
      addNewMode, rowData, editFormHeight, editFormTitle,
      showEditSchoolForm,
      selectedStartDate,
      selectedEndDate,
      membersLookupData,
      showAddMemberPopup,
      selectedCommitteeId,
      selectedSchoolYearId,
      membersGridRef,
    } = this.state;
    return (
      <>
        <div className="title">
          <span>Committees</span>
        </div>
        {this.renderEditSchoolPopup(showEditSchoolForm)}

        <>
          {showEditForm && (
            <Popup
              ref={(ref) => { this.editCommitteePopup = ref; }}
              id="editCommitteePopup"
              visible
              onHiding={(e) => { e.cancel = true; this.editCommitteeFormRef.current.cancelData(); }}
              onShown={(e) => {
                this.setState({ editFormHeight: e.component.content().closest('.dx-overlay-content').offsetHeight });
              }}
              {...appConst.defaultPopupOptions}
              title={editFormTitle}
            >
              <EditCommitteeForm
                ref={this.editCommitteeFormRef}
                className="editCommitteePopup"
                committeeId={committeeId}
                schoolYearsData={schoolYearsData}
                addNewMode={addNewMode}
                rowData={rowData}
                committeeGroupsData={this.committeeGroupsData}
                refreshGrid={this.refreshGrid}
                editFormHeight={editFormHeight}
                changeEditFormTitle={this.changeEditFormTitle}
                setMemberAutoCompleteSearchProperties={this.setMemberAutoCompleteSearchProperties}
                hideEditPopup={this.hideEditPopup}
                showHideSchoolEditForm={this.showHideSchoolEditForm}
              />
            </Popup>
          )}
          {showAddMemberPopup && (
            <AddMemberPopup
              membersLookupData={membersLookupData}
              showAddMemberPopup={showAddMemberPopup}
              selectedCommitteeId={selectedCommitteeId}
              selectedSchoolYearId={selectedSchoolYearId}
              hideAddMemberPopup={this.hideAddMemberPopup}
              membersGridRef={membersGridRef}
              selectedStartDate={selectedStartDate}
              selectedEndDate={selectedEndDate}
            />
          )}
        </>
        <DataGrid
          id="CommitteesGrid"
          ref={this.CommitteesGridRef}
          dataSource={dataSource}
          {...appConst.defaultGridOptions}
          {...standardRowRenderingMode}
          onToolbarPreparing={this.onToolbarPreparing}
          onRowDblClick={(e) => {
            this.editIconClick(e.data);
          }}
          elementAttr={{
            class: "committeesGrid",
          }}
          onInitialized={(e) => {
            e.component.option('height', calcGridHeight(e.component.element().id));
          }}
        >
          <Selection mode="multiple" />
          <SearchPanel
            visible
            width={240}
            placeholder="Search..."
          />
          <Editing
            mode="row"
            allowAdding={false}
            allowDeleting
            allowUpdating
          />
          <Column
            dataField="Description"
            dataType="string"
            sortOrder="asc"
            sortIndex="1"
          />
          <Column dataField="GroupId" dataType="number" calculateDisplayValue="CommitteeGroupName" caption="Group Name" />
          <Column
            dataField="Current"
            filterValue
            dataType="boolean"
            sortOrder="desc"
            sortIndex="0"
          />
          <Column
            type="buttons"
            width={110}
            buttons={['delete', {
              hint: 'Edit',
              icon: 'edit',
              onClick: (e) => {
                this.editIconClick(e.row.data);
              },
            },
              {
                hint: 'Copy Emails',
                icon: 'copy',
                onClick: (e) => {
                  const menu = this.getContextMenu();
                  menu.option('target', e.event.target);
                  menu.option('committeeId', e.row.data.Id);
                  menu.option('description', e.row.data.Description);
                  menu.show();
                }
               }
            ]}
          />
          <Template name="switchCurrent" render={this.toolbarItemRender} />
          <ColumnChooser
            enabled
            mode="dragAndDrop"
          />
          <Grouping
            allowCollapsing
            autoExpandAll={false}
            contextMenuEnabled
            expandMode="rowClick"
          />
          <GroupPanel
            visible
            allowColumnDragging
          />
          <HeaderFilter
            visible
          >
            <Search enabled={true}/>
          </HeaderFilter>
          <FilterRow visible />
          <FilterPanel visible />
        </DataGrid>
        <DxContextMenu
          id="contextMenu"
          dataSource={[{ text: "Home Emails" }, { text: "Work Emails" }]}
          width={200}
          onItemClick={async (e) => {
            try {
              let emailType = null;

              if (e.itemData.text === "Home Emails") {
                emailType = "home";
              } else {
                emailType = "work";
              }

              let menu = this.getContextMenu();

              if (menu.option('committeeId') === undefined) return;

              const emails = await this.fetchEmails(emailType);

              const joinedNamesWithEmails = emails.map(x => x.description).join(";");
             
              await navigator.clipboard.writeText(joinedNamesWithEmails);

              const description = menu.option('description');

              notify({ message: `${emails.length} of ${emailType} Email addresses for (${description}) have been copied to clipboard`, shading: true }, 'success');

              menu.option('description', undefined);
              menu.option('committeeId', undefined);

            } catch (error) {
              notify({ message: error.message, shading: true }, 'error');
            }
          }}
        />
      </>
    );
  }
}
